<template>
  <div>
    <el-table class="table"
              :header-cell-style="cellStyle"
              :data="tableData"
              :default-expand-all="tableprop.expand_all"
              :show-header="tableprop.show_header"
              :row-key="tableprop.row_key"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
              @selection-change="handleSelectionChange"
              @row-click="handleRowClick">
      <el-table-column type="selection"
                       width="55"
                       v-if="isSelected">
      </el-table-column>
      <template v-for="(item,index) in tableHeadList">
        <el-table-column v-if="item.slot && !item.slotheader"
                         :key="index"
                         v-bind="item.data"
                         align="left"
                         fixed="right">
          <template slot-scope="scope">
            <slot :scope="scope"
                  :name="item.slot"></slot>
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.slot && item.slotheader"
                         :key="index"
                         v-bind="item.data"
                         align="left"
                         fixed="right">
          <template slot="header">
            <slot name="tooltip"></slot>
          </template>
          <template slot-scope="scope">
            <slot :scope="scope"
                  :name="item.slot"></slot>
          </template>
        </el-table-column>
        <el-table-column v-else
                         :key="index"
                         :width="item.data.width"
                         v-bind="item.data"
                         :formatter="fieldFormatter"
                         :show-overflow-tooltip="true"
                         :render-header="renderHeader"></el-table-column>
      </template>
    </el-table>
    <div class="p-contianer"
         v-if="hasPagination">
      <el-pagination :current-page="pageNumber"
                     :page-sizes="pageSizes"
                     :page-size="pageSize"
                     :total="total"
                     class="p-bar"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange" />
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'commonTable',
  components: {

  },
  data () {
    return {
      deviceStatus: {
        0: 'Inactivated',
        1: 'Activated',
        2: 'To be Updated',
        4: 'Expired',
      },
      selectData: {
        title: "Share",
        show: false,
        row: [],
      },
      pageSizes: [10, 15, 30, 60, 100],
    }
  },
  props: {
    tableHeadList: {
      type: Array,
      default: () => {
        return []
      }
    },

    customClumn: {
      type: Array,
      default: () => {
        return []
      }
    },
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    },

    tableprop: {
      type: Object,
      default: () => {
        return {
          expand_all: false,
          show_header: true
        }
      }
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    pageNumber: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },

    total: Number,
    hasPagination: {
      type: Boolean,
      default: false
    }
  },
  watch: {

  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  methods: {
    //表头样式
    renderHeader (h, data) {
      return h("span", [
        h(
          "el-tooltip",
          {
            attrs: {
              class: "item",
              effect: "dark",
              content: data.column.label,
              placement: "top",
            },
          },
          [h("span", data.column.label)]
        ),
      ]);
    },
    // 更改每页展示数量
    handleSizeChange (val) {
      this.$emit('handleSizeChange', val)
    },
    // 更改当前页数
    handleCurrentChange (val) {
      this.$emit('handleCurrentChange', val)
    },


    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return { background: '#F5F7FA', 'font-weight': '500', color: '#333940' }
      }

    },

    handleRowClick (row, column, event) {
      this.$emit('rowClick', row, column)
    },

    fieldFormatter (row, column) {
      switch (column.property) {
        case 'createdDate':
          return moment(row.createTime).format('YYYY-MM-DD HH:mm:ss')
          break
        default:
          return row[column.property]
      }
    },


    handleSelectionChange (data) {
      this.selectData.row = data;
      this.$emit('getSelectDate', this.selectData)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>